import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { PositionCustodyFilter } from '../interfaces/position-custody-filter';

@Injectable({
  providedIn: 'root',
})
export class PositionConsultListService {
  filters: BehaviorSubject<PositionCustodyFilter> = new BehaviorSubject({} as PositionCustodyFilter);

  patchFilters(patch: Partial<PositionCustodyFilter>): void {
    const merged = this.normalize({ ...this.filters.value, ...patch });
    this.emitIfChanged(merged);
  }

  setFilters(filters: PositionCustodyFilter): void {
    this.emitIfChanged(this.normalize(filters));
  }

  private emitIfChanged(next: PositionCustodyFilter): void {
    if (!this.shallowCompare(this.filters.value, next)) {
      this.filters.next(next);
    }
  }

  private normalize(f: PositionCustodyFilter): PositionCustodyFilter {
    const out: PositionCustodyFilter = { ...f };
    const trimString = (s?: string | null) => {
      if (s === null || s === undefined) {
        return undefined;
      }
      const value = s.trim();
      return value.length ? value : undefined;
    };

    out.carbonCreditCode = trimString(out.carbonCreditCode);
    out.accountCode = trimString(out.accountCode);
    out.projectId = trimString(out.projectId);
    out.participantSimplifiedName = trimString(out.participantSimplifiedName);
    out.positionDate = trimString(out.positionDate as string | null | undefined);

    if (out.financialInstrumentCode === null || out.financialInstrumentCode === undefined) {
      out.financialInstrumentCode = undefined;
    } else if (typeof out.financialInstrumentCode === 'string') {
      out.financialInstrumentCode = trimString(out.financialInstrumentCode);
    }

    return out;
  }

  shallowCompare(a: PositionCustodyFilter, b: PositionCustodyFilter): boolean {
    if (a === b) {
      return true;
    }

    if (!a || !b) {
      return false;
    }

    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    for (const key of keys) {
      if ((a as Record<string, unknown>)[key] !== (b as Record<string, unknown>)[key]) {
        return false;
      }
    }

    return true;
  }
}
